/** biome-ignore-all lint/style/noMagicNumbers: TODO: fix */
import { Card, Col, Progress as CustomProgress, Form, Row, Tooltip } from 'antd';
import moment from 'moment';

import { getLocalDateTime } from '@/utils/date';
import WarningModal from '@/views/components/Modals/WarningModal';

import FormDatePicker from '../../../components/Inputs/FormDatePicker';
import FormInput from '../../../components/Inputs/FormInput';
import FormSelectBox from '../../../components/Inputs/FormSelectBox';
import FormTextArea from '../../../components/Inputs/FormTextArea';
import SecondaryLabel from '../../../components/Labels/SecondaryLabel';
import AlertModal from '../../../components/Modals/AlertModal';
import CommonModal from '../../../components/Modals/CommonModal';
import ConfirmationModal from '../../../components/Modals/ConfirmationModal';
import Paper from '../../../components/Paper/Paper';
import { PICKUP_TIME_OPTIONS } from '../shipment/constants';
import ProductTypes from './ProductTypes';

export default function StoreTrailerRequest({
  userType,
  trailerOptions,
  fullName,
  branchAddr1,
  nameLabel,
  formAddTrailerRequest,
  trlHidden,
  selectedTrailerPickValue,
  selectLocationID,
  partnerLocationOptions,
  commodityOptions,
  branchDesc,
  selectSpecialInstruction,
  selectLiveLoad,
  selectDoorType,
  shouldToggleChecked,
  openRequestPopup,
  closeModal,
  selectdeliveryCommodity,
  setLiveLoadUnloadHour,
  selectProduct,
  selectCommodity,
  setSupplierPhone,
  selectRequestDate,
  selectTrailerName,
  handleAlertClose,
  handleAlertOk,
  saveTrailerRequestData,
  locationLabel,
  addressLabel,
  phoneLabel,
  pickupTimeLabel,
  pickupDateLabel,
  selectedTrailerDoorValue,
  selectedLoadValue,
  liveLoadHoursOptions,
  trailerName,
  deliveryTime,
  branchBusPhone,
  rscm,
  scs,
  newErrorAlert,
  errorMessage,
  alertOpen,
  alertMessage,
  onConfirmFunc,
  isLoadedPickUp,
  isEmptyPickUp,
  isLoadedDelivered,
  hidden,
  deliveryDate,
  isLiveLoad,
  setHidden,
  selectDeliveryTime,
  selectDeliveryDate,
  trailerSizeOptions,
  selectTrailerSize,
  selectedValue,
  selectDelivered,
  checked1,
  handleChangeMultiStopY,
  handleChangeMultiStopN,
  selectStop1,
  stop1,
  selectStop2,
  stop2,
  selectStop3,
  stop3,
  deliveryTimeOptions,
  loadTrailer,
  warningModal,
  setWarningModal,
  warning,
  districtManager,
  percentage,
  progressBarColor,
  isEmptyDelivered,
  liveLoadHours,
  productTypeName,
  productType,
  tableData,
  setTableData,
  setPercentage,
  branchContact,
  selectRequestTimeframe,
  setFullName,
}) {
  const isMixed = Number(productType) === 5 && branchContact === 'Y';
  return (
    <>
      <Row gutter={20}>
        <Col sm={24}>
          <span className="pull-right color-1">
            {' '}
            <strong> {userType} </strong> Logged In{' '}
          </span>
        </Col>
      </Row>
      <div className="h-100 pb-15">
        <Row className="flex-direction-column flex-nowrap  h-100 ">
          <Col className="flex-1 custom-scroll-bar">
            <ConfirmationModal
              title="Alert"
              open={newErrorAlert}
              description={errorMessage}
              onOk={onConfirmFunc}
              onClose={onConfirmFunc}
              onCancel={onConfirmFunc}
              cancelButton
              okText="Ok"
              okButtonVariant="error"
            />
            <AlertModal
              title="Alert"
              open={alertOpen}
              description={alertMessage}
              onOk={handleAlertOk}
              onClose={handleAlertClose}
            />
            <WarningModal
              alertTitle="Warning"
              open={warningModal}
              description={warning}
              onClose={() => setWarningModal(false)}
              onOk={() => setWarningModal(false)}
            />
            <Form form={formAddTrailerRequest}>
              <div className="pb-5">
                <Paper className="mb-10 trailer-request-top-paper">
                  <div className="p-10">
                    <Row gutter={15}>
                      <Col
                        sm={4}
                        className="px-10"
                        style={{
                          borderRight: '5px solid #00557d26',
                          minHeight: '50vh',
                        }}
                      >
                        <div className="text-center mb-2">
                          <SecondaryLabel className="f-14">
                            {' '}
                            <u>Requester Details</u>{' '}
                          </SecondaryLabel>
                        </div>

                        <Row gutter={15}>
                          <Col sm={24}>
                            <FormInput
                              name="txtfullname"
                              label={nameLabel}
                              margin="m-0"
                              editMode
                              value={fullName}
                              placeholder="Auto populated value"
                              onChange={(e) => setFullName(e.target.value)}
                              defaultValue={fullName}
                            />
                          </Col>

                          <Col sm={24}>
                            {userType !== 'CT' && userType !== 'Supplier' && (
                              <FormInput
                                name="districtManager"
                                label="District Manager"
                                margin="m-0"
                                editMode
                                value={districtManager}
                                placeholder="SCS"
                                defaultValue={districtManager}
                              />
                            )}
                          </Col>

                          <Col sm={24}>
                            {userType !== 'CT' && userType !== 'Supplier' && (
                              <FormInput
                                name="txtscs"
                                label="SCS"
                                margin="m-0"
                                editMode
                                value={scs}
                                placeholder="SCS"
                                defaultValue={scs}
                              />
                            )}
                          </Col>

                          <Col sm={24}>
                            {userType !== 'CT' && userType !== 'Supplier' && (
                              <FormInput
                                name="txtrscm"
                                label="RSCM"
                                margin="m-0"
                                editMode
                                value={rscm}
                                placeholder="Auto populated value"
                                defaultValue={rscm}
                              />
                            )}
                          </Col>

                          <Col sm={24}>
                            {userType !== 'CT' && (
                              // biome-ignore lint/correctness/useUniqueElementIds: TODO: Fix This
                              <FormSelectBox
                                label={locationLabel}
                                editMode
                                name="PartnerLocation"
                                id="selPartnerLocation"
                                margin="m-0"
                                options={partnerLocationOptions}
                                placeholder="Select Partner Location"
                                onChange={selectLocationID}
                                defaultValue={branchDesc}
                                disabled
                              />
                            )}
                          </Col>

                          <Col sm={24}>
                            {userType !== 'CT' && (
                              <FormInput
                                name="txtaddr1"
                                label={addressLabel}
                                margin="m-0"
                                editMode
                                value={branchAddr1}
                                placeholder="Auto populated value"
                                defaultValue={branchAddr1}
                                disabled
                              />
                            )}
                          </Col>

                          <Col sm={24}>
                            {userType !== 'CT' && (
                              <FormInput
                                name="txtphone"
                                label={phoneLabel}
                                margin="m-0"
                                editMode
                                value={branchBusPhone}
                                placeholder="Phone Number"
                                defaultValue={branchBusPhone}
                                readOnly={userType !== 'Supplier'}
                                rules={[
                                  {
                                    message: 'Please enter a valid phone number (only numbers, +, and - are allowed)',
                                    pattern: /^[0-9+ -]*$/,
                                  },
                                ]}
                                onChange={setSupplierPhone}
                              />
                            )}
                          </Col>
                        </Row>
                      </Col>

                      <Col sm={20} className="px-10">
                        <Card title="Pickup" headStyle={{ textAlign: 'center' }} className="mb-4" bordered>
                          <Row gutter={15}>
                            <Col sm={16}>
                              <Row gutter={15} className="mb-5">
                                <Col sm={9}>
                                  <SecondaryLabel className="f-12">We need a trailer picked up:</SecondaryLabel>
                                </Col>

                                <Col sm={15}>
                                  <Row gutter={15}>
                                    <Col>
                                      {/** biome-ignore lint/correctness/useUniqueElementIds: TODO: Fix This */}
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="pickLoaded"
                                        checked={selectedTrailerPickValue === 'Loaded'}
                                        id="pickLoaded"
                                        value="Loaded"
                                        onClick={shouldToggleChecked}
                                      />
                                      <SecondaryLabel className="f-12"> Loaded </SecondaryLabel>
                                    </Col>
                                    {userType !== 'Supplier' && (
                                      <Col>
                                        {/** biome-ignore lint/correctness/useUniqueElementIds: TODO: Fix This  */}
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          name="pickEmpty"
                                          id="pickEmpty"
                                          checked={selectedTrailerPickValue === 'Empty'}
                                          value="Empty"
                                          onClick={shouldToggleChecked}
                                        />
                                        <SecondaryLabel className="f-12"> Empty </SecondaryLabel>
                                      </Col>
                                    )}
                                    <Col>
                                      {/** biome-ignore lint/correctness/useUniqueElementIds: TODO: Fix This */}
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="pickNone"
                                        id="pickNone"
                                        checked={selectedTrailerPickValue === 'None'}
                                        value="None"
                                        onClick={shouldToggleChecked}
                                      />
                                      <SecondaryLabel className="f-12"> None of the above </SecondaryLabel>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>

                              <Row gutter={15}>
                                <Col sm={4} hidden={trlHidden}>
                                  {/** biome-ignore lint/correctness/useUniqueElementIds:  TODO: Fix This  */}
                                  <FormSelectBox
                                    label="Trailer Number"
                                    editMode
                                    id="selTrailerName"
                                    name="trailerName"
                                    margin="m-0"
                                    loading={loadTrailer}
                                    options={trailerOptions}
                                    placeholder="Select Trailer"
                                    onChange={selectTrailerName}
                                  />
                                </Col>
                                <Col sm={4}>
                                  <FormSelectBox
                                    label="Trailer Size"
                                    editMode
                                    name="trailerSize"
                                    margin="m-0"
                                    options={trailerSizeOptions}
                                    placeholder="Trailer Size"
                                    onChange={selectTrailerSize}
                                    disabled
                                  />
                                </Col>

                                <Col sm={4}>
                                  <FormDatePicker
                                    label={pickupDateLabel}
                                    name="trailerDate"
                                    margin="m-0"
                                    onChange={selectRequestDate}
                                    allowClear={false}
                                  />
                                </Col>

                                <Col sm={4}>
                                  <FormSelectBox
                                    label={pickupTimeLabel}
                                    editMode
                                    name="selectPickupTime"
                                    margin="m-0"
                                    onChange={selectRequestTimeframe}
                                    placeholder={pickupTimeLabel}
                                    options={PICKUP_TIME_OPTIONS}
                                  />
                                </Col>

                                <Col sm={4}>
                                  {/** biome-ignore lint/correctness/useUniqueElementIds: TODO: Fix this */}
                                  <FormSelectBox
                                    label="Pickup Location"
                                    editMode
                                    name="pickupLocation"
                                    id="pickupLocation"
                                    margin="m-0"
                                    disabled
                                    options={partnerLocationOptions}
                                    placeholder="Pickup Location"
                                  />
                                </Col>
                              </Row>
                            </Col>
                          </Row>

                          {(isLoadedPickUp || isEmptyPickUp) && (
                            <Row gutter={15} className="mt-5">
                              <Col sm={18}>
                                <Row gutter={15}>
                                  <Col sm={6}>
                                    <FormSelectBox
                                      label="Commodity:"
                                      editMode
                                      name="Commodity"
                                      margin="m-0"
                                      options={commodityOptions}
                                      placeholder="Commodity"
                                      onChange={selectCommodity}
                                      disabled={isEmptyPickUp}
                                    />
                                  </Col>
                                  {isLoadedPickUp && (
                                    <ProductTypes
                                      isMixed={isMixed}
                                      productType={productType}
                                      form={formAddTrailerRequest}
                                      commodityOptions={commodityOptions}
                                      tableData={tableData}
                                      setTableData={setTableData}
                                      productTypeName={productTypeName}
                                      selectProduct={selectProduct}
                                      trailerSizeOptions={trailerSizeOptions}
                                      setPercentage={setPercentage}
                                    />
                                  )}
                                </Row>
                              </Col>

                              {isLoadedPickUp && (
                                <Col sm={6}>
                                  <div className="progress-container">
                                    <div className="text-center" style={{ color: progressBarColor }}>
                                      {percentage.toFixed(1)}% utilized
                                    </div>
                                    <CustomProgress
                                      percent={percentage}
                                      size={[280, 25]}
                                      strokeLinecap="butt"
                                      strokeColor={progressBarColor}
                                      showInfo={false}
                                    />
                                  </div>
                                </Col>
                              )}
                            </Row>
                          )}
                        </Card>
                        <Card title="Delivery" headStyle={{ textAlign: 'center' }} className="mb-4" bordered>
                          <Row gutter={20} className="mt-5">
                            <Col sm={16}>
                              <Row gutter={15}>
                                <Col sm={9}>
                                  <SecondaryLabel className="f-12"> We need a trailer delivered: </SecondaryLabel>
                                </Col>
                                <Col sm={15}>
                                  <Row gutter={15}>
                                    {userType !== 'Supplier' && (
                                      <Col>
                                        {/** biome-ignore lint/correctness/useUniqueElementIds: TODO: Fix this */}
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          name="deliveryLoaded"
                                          checked={selectedValue === 'Loaded'}
                                          value="Loaded"
                                          onClick={selectDelivered}
                                          id="Loaded"
                                        />
                                        <SecondaryLabel className="f-12"> Loaded </SecondaryLabel>
                                      </Col>
                                    )}
                                    <Col>
                                      {/** biome-ignore lint/correctness/useUniqueElementIds: TODO: Fix this  */}
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="deliveryEmpty"
                                        checked={selectedValue === 'Empty'}
                                        value="Empty"
                                        id="Empty"
                                        onClick={selectDelivered}
                                      />
                                      <SecondaryLabel className="f-12"> Empty </SecondaryLabel>
                                    </Col>

                                    <Col>
                                      {/** biome-ignore lint/correctness/useUniqueElementIds: TODO: Fix this  */}
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="deliveryNone"
                                        checked={selectedValue === 'None'}
                                        value="None"
                                        id="None"
                                        onClick={selectDelivered}
                                      />
                                      <SecondaryLabel className="f-12"> None of the above </SecondaryLabel>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row gutter={10} className="mt-5">
                                <Col sm={6}>
                                  <FormDatePicker
                                    label="Delivery Date "
                                    name="deliveryDate"
                                    margin="m-0"
                                    value={getLocalDateTime()}
                                    onChange={selectDeliveryDate}
                                    allowClear={false}
                                    disabledTargetDate={getLocalDateTime()}
                                    disableFuture={false}
                                  />
                                </Col>

                                <Col sm={6}>
                                  <SecondaryLabel className="f-12 text-black"> Delivery Time </SecondaryLabel>
                                  <FormSelectBox
                                    editMode
                                    className="mt-2 w-100"
                                    name="selectDeliveryTime"
                                    margin="m-0"
                                    onChange={selectDeliveryTime}
                                    placeholder="Delivery Location"
                                    options={deliveryTimeOptions}
                                  />
                                </Col>
                                <Col sm={6}>
                                  <FormSelectBox
                                    label="Delivery Location"
                                    editMode
                                    name="deliveryLocation"
                                    margin="m-0"
                                    disabled
                                    placeholder="Delivery Location"
                                    options={partnerLocationOptions}
                                  />
                                </Col>
                              </Row>
                            </Col>

                            <Col sm={8}>
                              <Row gutter={15}>
                                <Col sm={24}>
                                  {userType !== 'Supplier' && (
                                    <Row gutter={20} className="mt-5">
                                      <Col sm={12}>
                                        <SecondaryLabel className="f-12">
                                          {' '}
                                          Multiple Stops needed for this trailer?:{' '}
                                        </SecondaryLabel>
                                      </Col>
                                      <Col sm={8}>
                                        <Row gutter={15}>
                                          <Col sm={12}>
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              value="option1"
                                              checked={checked1}
                                              onChange={handleChangeMultiStopY}
                                            />
                                            <SecondaryLabel className="f-12">Yes</SecondaryLabel>
                                          </Col>
                                          <Col sm={12}>
                                            <input
                                              className="form-check-input"
                                              checked={checked1 === false}
                                              type="checkbox"
                                              value="option2"
                                              onChange={handleChangeMultiStopN}
                                            />
                                            <SecondaryLabel className="f-12"> No </SecondaryLabel>
                                          </Col>
                                        </Row>
                                      </Col>
                                    </Row>
                                  )}
                                  {checked1 && (
                                    <Row gutter={15}>
                                      <Col sm={8}>
                                        <FormSelectBox
                                          label="Stop 1"
                                          editMode
                                          name="stop1"
                                          margin="m-0"
                                          options={partnerLocationOptions}
                                          placeholder="Select 1st Stop"
                                          onChange={selectStop1}
                                          value={stop1}
                                        />
                                      </Col>

                                      <Col sm={8}>
                                        <FormSelectBox
                                          label="Stop 2"
                                          editMode
                                          name="stop2"
                                          margin="m-0"
                                          options={partnerLocationOptions}
                                          placeholder="Select 2nd Stop"
                                          onChange={selectStop2}
                                          value={stop2}
                                        />
                                      </Col>

                                      <Col sm={8}>
                                        <FormSelectBox
                                          label="Stop 3"
                                          editMode
                                          name="stop3"
                                          margin="m-0"
                                          options={partnerLocationOptions}
                                          placeholder="Select 3rd Stop"
                                          onChange={selectStop3}
                                          value={stop3}
                                        />
                                      </Col>
                                    </Row>
                                  )}
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          {(isLoadedDelivered || isEmptyDelivered) && (
                            <Row gutter={20} className="mt-5">
                              <Col sm={18}>
                                <Row gutter={20} className="mb-2">
                                  <Col sm={6}>
                                    <FormSelectBox
                                      label="Commodity:"
                                      editMode
                                      name="Commodity1"
                                      margin="m-0"
                                      options={commodityOptions}
                                      placeholder="Commodity"
                                      onChange={selectdeliveryCommodity}
                                    />
                                  </Col>
                                </Row>
                              </Col>

                              <Col sm={6}>
                                <div className="p-10 mt-2 background-danger-1" hidden>
                                  <SecondaryLabel className="f-12 text-white">
                                    {' '}
                                    Trailer # 25468 is 90% consumed{' '}
                                  </SecondaryLabel>
                                </div>
                              </Col>
                            </Row>
                          )}
                        </Card>
                      </Col>
                    </Row>
                  </div>
                </Paper>

                <CommonModal
                  className="w-35 h-60"
                  open={hidden}
                  title="Trailer Request Confirmation"
                  onClose={() => setHidden(false)}
                  // biome-ignore lint/complexity/noUselessFragments: placeholder
                  customFooter={<></>}
                >
                  <div className="p-4">
                    <div className="alert alert-info mb-4">
                      <i className="fas fa-info-circle mr-2"></i>
                      Please review your trailer request details before submission. Once confirmed, the request will be
                      processed by our team.
                    </div>

                    <div className="trailer-details-card p-4 mb-4">
                      <h6 className="font-weight-bold mb-4 text-uppercase">
                        <i className="fas fa-trailer mr-2"></i>Trailer Information
                      </h6>

                      <Row gutter={[16, 16]} className="mb-3">
                        <Col xs={24} md={8} className="font-weight-medium">
                          Trailer #:
                        </Col>
                        <Col xs={24} md={16}>
                          {trailerName || 'N/A'}
                        </Col>
                      </Row>
                      <Row gutter={[16, 16]} className="mb-3">
                        <Col xs={24} md={8} className="font-weight-medium">
                          Request Type:
                        </Col>
                        <Col xs={24} md={16}>
                          <div className="d-flex flex-wrap gap-2">
                            {(isLoadedPickUp || isEmptyPickUp) && (isLoadedDelivered || isEmptyDelivered) ? (
                              <span>
                                Pickup {isLoadedPickUp ? 'Loaded' : 'Empty'} <span>AND</span> Deliver{' '}
                                {isLoadedDelivered ? 'Loaded' : 'Empty'}
                              </span>
                            ) : isLoadedPickUp || isEmptyPickUp ? (
                              <span>Pickup {isLoadedPickUp ? 'Loaded' : 'Empty'}</span>
                            ) : isLoadedDelivered || isEmptyDelivered ? (
                              <span>Deliver {isLoadedDelivered ? 'Loaded' : 'Empty'}</span>
                            ) : (
                              <span>Standard Request</span>
                            )}
                          </div>
                        </Col>
                      </Row>
                      {productTypeName && (
                        <Row>
                          <Col xs={24} md={8} className="font-weight-medium">
                            <span>Product Type:</span>
                          </Col>
                          <Col xs={24} md={16}>
                            {productTypeName}
                          </Col>
                        </Row>
                      )}

                      {selectLocationID && (
                        <Row gutter={[16, 16]} className="mb-3">
                          <Col xs={24} md={8} className="font-weight-medium">
                            Location:
                          </Col>
                          <Col xs={24} md={16}>
                            {branchDesc || formAddTrailerRequest.getFieldValue('pickupLocation')}
                          </Col>
                        </Row>
                      )}

                      <Row gutter={[16, 16]} className="mb-3">
                        <Col xs={24} md={8} className="font-weight-medium">
                          Request Date:
                        </Col>
                        <Col xs={24} md={16}>
                          {deliveryDate ? moment(deliveryDate).format('D MMMM YYYY') : 'N/A'}
                        </Col>
                      </Row>

                      {deliveryTime && (
                        <Row gutter={[16, 16]} className="mb-3">
                          <Col xs={24} md={8} className="font-weight-medium">
                            Requested Time:
                          </Col>
                          <Col xs={24} md={16}>
                            {deliveryTime}
                          </Col>
                        </Row>
                      )}

                      {selectedTrailerDoorValue && (
                        <Row gutter={[16, 16]} className="mb-3">
                          <Col xs={24} md={8} className="font-weight-medium">
                            Trailer Door Type:
                          </Col>
                          <Col xs={24} md={16}>
                            {selectedTrailerDoorValue === 'RollUpdoor' ? 'Roll Door' : 'Swing Door'}
                          </Col>
                        </Row>
                      )}

                      {isLiveLoad && (
                        <div className="mt-3 pt-3 border-top">
                          <Row gutter={[16, 16]}>
                            <Col xs={24} md={8} className="font-weight-medium">
                              Live Load Hours:
                            </Col>
                            <Col xs={24} md={16}>
                              {liveLoadHours}
                            </Col>
                          </Row>
                        </div>
                      )}
                    </div>
                    <div className="text-center" style={{ marginTop: '80px' }}>
                      <button type="button" className="btn btn-dipblue mr-5" onClick={saveTrailerRequestData}>
                        {' '}
                        Proceed{' '}
                      </button>
                      <button type="button" className="btn btn-dipblue" onClick={closeModal}>
                        {' '}
                        Cancel{' '}
                      </button>
                    </div>
                  </div>
                </CommonModal>

                <Paper>
                  <div className="card-header p-8">
                    <SecondaryLabel className="f-14 text-white"> Special Instructions </SecondaryLabel>
                  </div>

                  <div className="p-10">
                    <Row gutter={15}>
                      <Col sm={8}>
                        <Row gutter={20} className="mb-5">
                          <Col sm={4}>
                            <SecondaryLabel className="f-12"> Trailer Door Type: </SecondaryLabel>
                          </Col>

                          <Col sm={20}>
                            <Row gutter={15}>
                              <Col>
                                {/** biome-ignore lint/correctness/useUniqueElementIds:TODO: Fix This */}
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  checked={selectedTrailerDoorValue === 'Swingdoor'}
                                  name="trlSwingdoor"
                                  value="SWNGDR"
                                  id="Swingdoor"
                                  onClick={selectDoorType}
                                />
                                <SecondaryLabel className="f-12"> Swing door </SecondaryLabel>
                              </Col>

                              <Col>
                                {/** biome-ignore lint/correctness/useUniqueElementIds:TODO: Fix This */}
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  checked={selectedTrailerDoorValue === 'RollUpdoor'}
                                  name="trlRollUpdoor"
                                  value="RLLUPDR"
                                  onClick={selectDoorType}
                                  id="RollUpdoor"
                                />
                                <SecondaryLabel className="f-12"> Roll door </SecondaryLabel>
                              </Col>
                            </Row>
                          </Col>
                        </Row>

                        <Row gutter={20} className="mb-2">
                          <Col sm={12}>
                            <Row gutter={15}>
                              <Col sm={12}>
                                <SecondaryLabel className="f-12"> Live Load / Unload: </SecondaryLabel>
                              </Col>
                              <Col sm={12}>
                                <Row gutter={15}>
                                  <Col>
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="rbLoad"
                                      checked={selectedLoadValue === 'Load'}
                                      value="Yes"
                                      onClick={selectLiveLoad}
                                    />
                                    <SecondaryLabel className="f-12"> Yes </SecondaryLabel>
                                  </Col>

                                  <Col>
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="rbUnload"
                                      checked={selectedLoadValue === 'UnLoad'}
                                      value="No"
                                      onClick={selectLiveLoad}
                                    />
                                    <SecondaryLabel className="f-12"> No </SecondaryLabel>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </Col>

                          <Col sm={8}>
                            {isLiveLoad && (
                              <FormSelectBox
                                label={
                                  <Tooltip title="Driver stays on site while loading/unloading 1-4 hours max.">
                                    Live Load / Unload Hours:
                                  </Tooltip>
                                }
                                editMode
                                name="LiveLoadHours"
                                margin="m-0"
                                options={liveLoadHoursOptions}
                                placeholder="Live Load/Unload Hours"
                                onChange={setLiveLoadUnloadHour}
                              />
                            )}
                          </Col>
                        </Row>
                      </Col>

                      <Col sm={5}>
                        <FormTextArea
                          editMode
                          name="txtSpclInstruct"
                          margin="mb-14"
                          placeholder="Special Instructions"
                          enableAutoFocus={false}
                          rows={3}
                          onChange={selectSpecialInstruction}
                        />
                      </Col>
                    </Row>
                  </div>
                </Paper>
                <div className="text-center">
                  <button type="button" className="btn btn-dipblue me-5" onClick={openRequestPopup}>
                    {' '}
                    Submit Request{' '}
                  </button>
                </div>
              </div>
            </Form>
          </Col>
        </Row>
      </div>
    </>
  );
}
